const rhm = window.rhm || {};

rhm.reset_inputs = () => {
  const variants_input = document.querySelectorAll(
    '.variants_container .cart_input',
  );
  for (let input of variants_input) {
    input.value = '0';
  }
  return true;
};

window.addEventListener('beforeunload', function (event) {
  rhm.reset_inputs();
});

rhm.addFreebie = (
  linked_product,
  freebie_container,
  freebies_childs_count,
  quantity_difference,
  variant_option1,
) => {
  const codeBlock = document.querySelector(
    `freebies-code-block[data-linked_product="${linked_product}"]`,
  ).firstElementChild;
  const total = freebies_childs_count + quantity_difference;
  for (let index = freebies_childs_count; index < total; index++) {
    const node = codeBlock.cloneNode(true);
    const customerName = rhm.getCustomerName();
    node.appendChild(customerName);
    node.querySelector('label').innerText = `${variant_option1.replaceAll(
      '-',
      ' ',
    )}`;
    freebie_container.appendChild(node);
  }
};

rhm.removeFreebie = (freebie_container, negative_quantity_difference) => {
  const quantity_difference = Math.abs(negative_quantity_difference);
  for (let index = 0; index < quantity_difference; index++) {
    freebie_container.removeChild(freebie_container.lastElementChild);
  }
};
rhm.addNames = (
  freebie_container,
  freebies_childs_count,
  quantity_difference,
  variant_option1,
) => {
  const total = freebies_childs_count + quantity_difference;
  for (let index = freebies_childs_count; index < total; index++) {
    const node = document.createElement('div');
    const customerName = rhm.getCustomerName();
    node.appendChild(customerName);
    node.querySelector('label').innerText = `${variant_option1.replaceAll(
      '-',
      ' ',
    )}`;
    freebie_container.appendChild(node);
  }
};

rhm.selectedSizes = () => {
  const inputs = document.querySelectorAll(
    'freebies-container freebies-select select',
  );
  const filteredInputs = [];
  for (let input of inputs) {
    const isAvab = input.getAttribute('data-avab') === 'true' ? true : false;
    if (!isAvab) continue;
    filteredInputs.push(input);
  }
  // Only added a sold out product.
  if (inputs.length === 1 && inputs[0].getAttribute('data-avab') === 'false') {
    filteredInputs.push(inputs[0]);
    rhm.setCartButtonStatus(1, 1);
    return;
  }

  const total = filteredInputs.length;
  let selectedCount = 0;
  for (let select of filteredInputs) {
    const value = select.value;
    if (value !== '-') selectedCount++;
  }
  document.querySelector('.freebies-selected').innerText = selectedCount;
  rhm.setCartButtonStatus(total, selectedCount);
};

rhm.setCartButtonStatus = (total, selectedCount) => {
  console.log(total, selectedCount);
  const cartButton = document.querySelector('.cartButton');
  const action = total !== selectedCount ? 'add' : 'remove';
  cartButton.classList[action]('disabled');
};

rhm.setTotalSizes = () => {
  const total = document.querySelectorAll(
    'freebies-container freebies-select',
  ).length;
  document.querySelector('.freebies-total').innerText = total;
};
rhm.getCustomerName = () => {
  const nameBlock = document.createElement('p');
  nameBlock.className = 'line-item-property__field';

  const nameLabel = document.createElement('label');
  nameLabel.setAttribute('for', 'first-name');
  nameLabel.innerText = 'First Name';

  const nameInput = document.createElement('input');
  nameInput.className =
    'required customer_name twcss-block twcss-mt-5 select__select';
  nameInput.setAttribute('required', true);
  nameInput.setAttribute('id', 'first-name');
  nameInput.setAttribute('text', 'text');
  nameInput.setAttribute('name', 'properties[First Name]');

  nameBlock.appendChild(nameLabel);
  nameBlock.appendChild(nameInput);
  return nameBlock;
};

rhm.countFreebiesFields = (variant_id) => {
  const freebie_container = document.querySelector(
    `freebies-variant[data-variant="${variant_id}"]`,
  );
  const freebies_childs = freebie_container.childNodes;
  const freebies_childs_count = freebies_childs.length;
  return { freebie_container, freebies_childs_count };
};
rhm.setFreebies = (variant) => {
  const linked_product = variant.getAttribute('data-linked_product');
  const variant_id = variant.getAttribute('data-variant');
  const variant_option1 = variant.getAttribute('data-option1');
  const variant_quantities = variant.value;
  const { freebie_container, freebies_childs_count } =
    rhm.countFreebiesFields(variant_id);

  if (variant_quantities === freebies_childs_count) return;
  const quantity_difference = variant_quantities - freebies_childs_count;

  if (quantity_difference > 0) {
    rhm.addFreebie(
      linked_product,
      freebie_container,
      freebies_childs_count,
      quantity_difference,
      variant_option1,
    );
  } else {
    rhm.removeFreebie(freebie_container, quantity_difference);
  }
  rhm.setTotalSizes();
  rhm.selectedSizes();
};

rhm.setNames = (variant) => {
  const variant_id = variant.getAttribute('data-variant');
  const variant_option1 = variant.getAttribute('data-option1');
  const variant_quantities = variant.value;
  const { freebie_container, freebies_childs_count } =
    rhm.countFreebiesFields(variant_id);
  if (variant_quantities === freebies_childs_count) return;
  const quantity_difference = variant_quantities - freebies_childs_count;
  if (quantity_difference > 0) {
    rhm.addNames(
      freebie_container,
      freebies_childs_count,
      quantity_difference,
      variant_option1,
    );
  } else {
    rhm.removeFreebie(freebie_container, quantity_difference);
  }
  rhm.setTotalSizes();
  rhm.selectedSizes();
};

rhm.validateSelect = (elem) => {
  const elemValue = elem.value;
  if (elemValue !== '-') {
    elem.closest('freebies-wrapper').classList.add('valid');
  } else {
    elem.closest('freebies-wrapper').classList.remove('valid');
  }
  rhm.selectedSizes();
};

rhm.addToCart = async (button) => {
  if (button.className.indexOf('disabled') !== -1) return;
  const items = [];

  const variants_input = document.querySelectorAll(
    '.variants_container .cart_input',
  );
  for (let input of variants_input) {
    const quantity = parseInt(input.value);
    if (quantity === 0) continue;
    const id = input.getAttribute('data-variant');
    items.push({
      id,
      quantity,
    });
  }

  const freebies_input = document.querySelectorAll(
    'freebies-container .cart_input',
  );
  for (let input of freebies_input) {
    let customerName;
    const wrapper = input.closest('freebies-select').nextElementSibling;
    const customerNameInput = wrapper.querySelector('.customer_name');
    if (customerNameInput !== null) {
      customerName = customerNameInput.value;
    }

    const quantity = 1;
    const id = input.value;
    if (id === '-') continue;
    const data = {
      id,
      quantity,
    };
    if (customerName !== null) {
      data.properties = {
        'First Name': customerName,
      };
    }
    items.push(data);
  }

  const result = await rhm.postData('/cart/add.js', { items });
  if (typeof result.items !== 'undefined') {
    window.location.href = '/cart';
  }
};

rhm.postData = async (url = '', data = {}) => {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
  return response.json();
};
